import { render } from "./ClientCompanies.vue?vue&type=template&id=9cf558fa&ts=true"
import script from "./ClientCompanies.vue?vue&type=script&lang=ts"
export * from "./ClientCompanies.vue?vue&type=script&lang=ts"

import "./ClientCompanies.vue?vue&type=style&index=0&id=9cf558fa&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__